export default __webpack_public_path__ + "static/media/reddit.f6858e44.webp";